<script lang="ts">
const shareSettingsUrl =
  'https://nomadeducation.onelink.me/1B9T?pid=appShare&amp;deep_link_value=nomadeducation-nomadeducation://nomadeducation.fr/settings'
</script>
<template>
  <ButtonBase
    theme="secondary"
    stroke="n"
    class="button"
    :disabled="false"
    rounded
    size="small"
    @click="handleClickShare"
  >
    <slot />
  </ButtonBase>
</template>
<script setup lang="ts">
import DialogShare from '~/components/dialog/share/DialogShare.vue';
interface Props {
  member: FamilyMember;
}

const props = defineProps({
  member: null
});

const { t } = useI18n();



const { displayName } = useFamilyMember(toRef(() => props.member));

const dialog = useDialogStore();

const shareText = computed(() => {
  return t('family.settings.share', {
    name: displayName.value,
    shareSettingsUrl,
  });
});

const { share, isSupported: isShareSupported } = useShare();

const handleClickShare = (e) => {
  if (isShareSupported.value) {
    share({
      text: shareText.value,
    });
    e.preventDefault();
  } else {
    dialog.open(DialogShare, {
      level: DialogLevel.Info,
      iconHeader: 'family',
      title: 'Partage',
      label: '',
      shareText: shareText.value,
    });
  }

  e.preventDefault();
};
</script>
<style lang="scss" scoped></style>
